import {
  STATUS_FILTER,
} from "../../../custom/Utils/ListFilterOptions";

const schema = localStorage.getItem("schema");
export const basicFormData = () => ({
  inputData: {
    menu_name: "",
    menu_url: "",
    menu_icon: "",
    is_child: false,
    parent_id: null,
    is_visible_on_mobile: true,
    sequence: null,
    created_by: 1,
    updated_by: 1,
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "menu_masters",
    schema: schema,
    relation: [
      {
        moduleAs: "menu_access",
        modelName: "menu_access_masters",
        foreignKey: "menu_id",
      },
      {
        moduleAs: "child_menus",
        modelName: "menu_masters",
        foreignKey: "parent_id",
      },
    ],
  };

  const navigatePage = { back: "/menu-list" };

  const headerName = "Menu";

  const validationType = "MenuCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";
  const dependentDropdownData = [
    {
      module_name: "menu_masters",
      initialPayload: {
        modelName: "menu_masters",
        schema: schema,
        whereCondition: { is_child: false },
        orderBy: {
          field: "menu_name",
          order: "asc",
        },
      },
      isOtherDependentOnThis: false,
      patchFieldName: "menu_name",
      dropdownDataValue: "parent_id",
      endPoint: "/getRecords",
    },
  ];
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    dependentDropdownData,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "menu_masters",
    schema: schema,
    include: [
      { model: "user_masters", as: "created_by_user" },
      { model: "user_masters", as: "updated_by_user" },
    ],
    // relations: [
    //   {
    //     module: "user_masters",
    //     moduleAs: "createdBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    // ],
  };

  const columnData = [
    { label: "sr.no", value: "index" },
    { label: "Menu Name", value: "menu_name" },
    { label: "Menu URL", value: "menu_url" },
    { label: "Menu Icon", value: "menu_icon" },
    { label: "Is Child", value: "is_child" },
    { label: "Is Visible On Mobile", value: "is_visible_on_mobile" },
    { label: "Created By", value: "created_by_user_full_name" },
    { label: "Updated By", value: "updated_by_user_full_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/menu-create",
    edit: "/menu-create",
    view: "/menu-view",
  };

  const searchfields = [
    "menu_name",
    "menu_url",
    "menu_icon",
    "created_by_user.first_name",
    "created_by_user.last_name",
    "updated_by_user.first_name",
    "updated_by_user.last_name",
  ];

  const headerName = "Menu";
  const endpoint = "/getRecords";
  const exportFileName = "menuData.xlsx";

  const filterConfig = [
    {
      key: "is_child",
      label: "Menu Type",
      width: 165,
      options: [
        { label: "Parent Menu", value: false },
        { label: "Child Menu", value: true },
      ],
    },
    STATUS_FILTER,
  ];

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
    filterConfig,
  };
};

export const exportPageData = {
  modelName: "menu_masters",
  schema: schema,
  // relations: [
  //   { module: "user_masters", moduleAs: "users" },
  //   { module: "user_masters", moduleAs: "users" },
  // ],
  pagination: { page: 1, pageSize: 10000 },
};
